export const ACCESS_TOKEN = 'access-token';
export const REFRESH_TOKEN = 'refresh-token';
export const LANGUAGE = 'language';
export const USER = 'user';
export const THEME = 'theme';
export const ITEMS_PER_PAGE = 'items-per-page';
export const DISPLAYED_MODULE_CONFIG_COLUMNS = 'displayed-module-config-columns';
export const DISPLAYED_BOX_COLUMNS = 'displayed-box-columns';
export const DISPLAYED_CUSTOMER_COLUMNS = 'displayed-customer-columns';
export const DISPLAYED_USER_COLUMNS = 'displayed-user-columns';
export const DISPLAYED_ADMIN_USER_COLUMNS = 'displayed-admin-user-columns';
export const DISPLAYED_PARTNER_COLUMNS = 'displayed-partner-columns';
export const SELECTED_CUSTOMER = 'selected-customer';
export const SELECTED_PARTNER = 'selected-partner';
export const IS_DEMO = 'is-demo';
